<div class="trinka_cloud_wrap">

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper align-items-center">
                        <div class="top-banner-left">
                            <h1>引用チェック</h1>
                            <h2>
                                研究の論拠を強化する<br/>
                                引用チェッカー
                            </h2>
                            <p>撤回された論文やAIがねつ造した論文タイトル、ハゲタカジャーナルの掲載論文などを引用してしまうリスクを検出し、原稿の論拠を確かなものに。</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank" rel="noopener noreferrer">引用チェッカーを使う</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="assets/images/features/features-page/citation-quality-check.webp" alt="引用チェッカー - 文法 チェック" class="img-fluid w-100 h-auto">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="assets/images/yt-thumbnail/citation-video.webp" alt="引用ビデオ - 英文校正" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2 pl-0">
                        <div class="trinka-title mb-0">
                            <h2>引用チェッカーの使い方</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>Trinka引用チェッカーの使い方は簡単です。</p>
                            <p>ウォークスルービデオで、各種機能のご利用方法を解説します。</p>
                            <p>ご不明点については、<a style="color: #0000ff;" (click)="scroll(target)" class="text-link">FAQ</a>も参考にしてください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinka引用チェッカーの主な機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaの引用チェッカーは、下記のようなリスクのある引用を検出。文献リストを改善し、研究の論拠を強化できる引用分析を行います。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="assets/images/Retracted-References.png" loading="lazy" decoding="async" alt="撤回された参考文献 - 文法 チェック">
                            </div>
                            <div class="media-body">
                                <h3>撤回された論文</h3>
                                <p>出版後に撤回された研究論文を特定し、査読者からの批判を回避します。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="assets/images/Non-standard-References.png" loading="lazy" decoding="async" alt="非標準 - 英文校正 ai">
                            </div>
                            <div class="media-body">
                                <h3>信頼性の低い論文</h3>
                                <p>引用データベースに索引されていない文献を除外し、引用の信頼性を向上させます。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 24.75H20.006M20 18.75V22.5M14 21.939C14 27.7042 19.1885 29.7292 19.9153 29.985C19.9718 30.005 20.0283 30.005 20.0848 29.985C20.813 29.7375 26 27.7635 26 21.9397V16.728C26.0002 16.6609 25.9779 16.5958 25.9367 16.5429C25.8955 16.49 25.8378 16.4525 25.7728 16.4362L20.0728 15.009C20.025 14.997 19.975 14.997 19.9273 15.009L14.2273 16.4362C14.1622 16.4525 14.1045 16.49 14.0633 16.5429C14.0221 16.5958 13.9998 16.6609 14 16.728V21.939Z" stroke="#763393" stroke-width="0.976431" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M35 3.5C35.2761 3.5 35.5 3.27614 35.5 3C35.5 2.72386 35.2761 2.5 35 2.5V3V3.5ZM35 3V2.5H7V3V3.5H35V3ZM7 7V7.5H35V7V6.5H7V7ZM5 5H4.5C4.5 6.38071 5.61929 7.5 7 7.5V7V6.5C6.17157 6.5 5.5 5.82843 5.5 5H5ZM7 3V2.5C5.61929 2.5 4.5 3.61929 4.5 5H5H5.5C5.5 4.17157 6.17157 3.5 7 3.5V3Z" fill="#4D4D4D"/>
                                    <path d="M35.5 7.03077C35.5 6.75463 35.2761 6.53077 35 6.53077C34.7239 6.53077 34.5 6.75463 34.5 7.03077H35H35.5ZM35 37V37.5H35.5V37H35ZM35 7.03077H34.5V37H35H35.5V7.03077H35ZM35 37V36.5H9V37V37.5H35V37ZM5 33H5.5V5H5H4.5V33H5ZM9 37V36.5C7.067 36.5 5.5 34.933 5.5 33H5H4.5C4.5 35.4853 6.51472 37.5 9 37.5V37Z" fill="#4D4D4D"/>
                                    <path d="M7 5H31.5" stroke="#4D4D4D" stroke-linecap="round"/>
                                </svg> 
                            </div>
                            <div class="media-body">
                                <h3>ハゲタカジャーナルの掲載論文</h3>
                                <p>原稿の信頼性を保護するために、ハゲタカジャーナルからの引用をフラグ付けします。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.05056 19.1919H12.9293H20.8081M5.05056 22.4242H12.9293H20.8081M5.05056 25.6566H12.9293H20.8081M5.05056 28.8889H12.9293H20.8081M23.2324 37.7273V11.1616C23.2324 10.9106 23.0289 10.7071 22.7778 10.7071H2.27278C2.02174 10.7071 1.81824 10.9106 1.81824 11.1616V37.7273C1.81824 37.9783 2.02175 38.1818 2.27278 38.1818H22.7778C23.0289 38.1818 23.2324 37.9783 23.2324 37.7273Z" stroke="#4D4D4D" stroke-linecap="round"/>
                                    <path d="M35.4512 16.4596C35.7273 16.4614 35.9527 16.239 35.9545 15.9629C35.9563 15.6867 35.7339 15.4614 35.4578 15.4596L35.4545 15.9596L35.4512 16.4596ZM35.4512 19.6919C35.7273 19.6937 35.9527 19.4713 35.9545 19.1952C35.9563 18.9191 35.7339 18.6937 35.4578 18.6919L35.4545 19.1919L35.4512 19.6919ZM25.4811 18.6261C25.205 18.6243 24.9797 18.8466 24.9778 19.1228C24.976 19.3989 25.1984 19.6242 25.4745 19.6261L25.4778 19.1261L25.4811 18.6261ZM25.4811 15.3938C25.205 15.3919 24.9797 15.6143 24.9778 15.8904C24.976 16.1666 25.1984 16.3919 25.4745 16.3937L25.4778 15.8937L25.4811 15.3938ZM25.4811 21.8584C25.205 21.8566 24.9797 22.079 24.9778 22.3551C24.976 22.6312 25.1984 22.8566 25.4745 22.8584L25.4778 22.3584L25.4811 21.8584ZM35.4512 22.9242C35.7273 22.926 35.9527 22.7037 35.9545 22.4275C35.9563 22.1514 35.7339 21.9261 35.4578 21.9242L35.4545 22.4242L35.4512 22.9242ZM25.4811 25.0907C25.205 25.0889 24.9797 25.3113 24.9778 25.5874C24.976 25.8636 25.1984 26.0889 25.4745 26.0907L25.4778 25.5907L25.4811 25.0907ZM35.4512 26.1565C35.7273 26.1584 35.9527 25.936 35.9545 25.6599C35.9563 25.3837 35.7339 25.1584 35.4578 25.1566L35.4545 25.6566L35.4512 26.1565ZM16.9191 7.47473V7.97473H37.4242V7.47473V6.97473H16.9191V7.47473ZM37.4242 34.9495V34.4495H24.1414V34.9495V35.4495H37.4242V34.9495ZM25.4778 19.1261L25.4745 19.6261L35.4512 19.6919L35.4545 19.1919L35.4578 18.6919L25.4811 18.6261L25.4778 19.1261ZM25.4778 15.8937L25.4745 16.3937L35.4512 16.4596L35.4545 15.9596L35.4578 15.4596L25.4811 15.3938L25.4778 15.8937ZM25.4778 22.3584L25.4745 22.8584L35.4512 22.9242L35.4545 22.4242L35.4578 21.9242L25.4811 21.8584L25.4778 22.3584ZM25.4778 25.5907L25.4745 26.0907L35.4512 26.1565L35.4545 25.6566L35.4578 25.1566L25.4811 25.0907L25.4778 25.5907ZM16.4646 10.7071H16.9646V7.92928H16.4646H15.9646V10.7071H16.4646ZM37.8787 7.92928H37.3787V21.2121H37.8787H38.3787V7.92928H37.8787ZM37.8787 21.2121H37.3787V34.4949H37.8787H38.3787V21.2121H37.8787ZM37.4242 34.9495V35.4495C37.9514 35.4495 38.3787 35.0221 38.3787 34.4949H37.8787H37.3787C37.3787 34.4698 37.3991 34.4495 37.4242 34.4495V34.9495ZM37.4242 7.47473V7.97473C37.3991 7.97473 37.3787 7.95438 37.3787 7.92928H37.8787H38.3787C38.3787 7.40209 37.9514 6.97473 37.4242 6.97473V7.47473ZM16.9191 7.47473V6.97473C16.392 6.97473 15.9646 7.4021 15.9646 7.92928H16.4646H16.9646C16.9646 7.95438 16.9442 7.97473 16.9191 7.97473V7.47473Z" fill="#4D4D4D"/>
                                    <path d="M12.3232 9.89899C12.3232 5.0505 15.8707 1.81818 20.2481 1.81818C23.8044 1.81818 26.6731 3.70505 27.6768 6.66666" stroke="#763393" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M24.4443 5.85857L27.6767 6.66665L28.4847 3.43433" stroke="#763393" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                    
                            </div>
                            <div class="media-body">
                                <h3>重複する参考文献</h3>
                                <p>文献リスト内の重複記載を検出し、クリーンかつジャーナルに掲載できるレベルに仕上げます。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="assets/images/Old-References.png" loading="lazy" decoding="async" alt="古いリファレンス - 文法 チェック">
                            </div>
                            <div class="media-body">
                                <h3>出版年の古い文献</h3>
                                <p>出版年度が古い文献を検出。最新の情報に依拠した論説を可能にします。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="assets/images/Overuse.png" loading="lazy" decoding="async" alt="使いすぎ - 英文校正">
                            </div>
                            <div class="media-body">
                                <h3>ジャーナルの偏り</h3>
                                <p>参考文献のジャーナルの偏りを特定。引用元を多様化して論文の根拠に説得力を与えます。</p>
                            </div>
                        </div>
                       
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features section-pd list-wrapper-style-2" style="background-color: #f3eef6;">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinka引用チェッカーが選ばれる理由</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="assets/images/languageScore_icon.svg" alt="無料の引用分析スコア - 文法 チェック" />
                            </div>
                            <div class="media-body">
                                <h3>引用分析スコア</h3>
                                <p>引用分析スコアは無料でご覧いただけます。必要に応じて、有料のレポートもご利用いただけます。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="assets/images/Up-to-date-Repository.png" alt="Crossrefの照会 - ai英文校正" />
                            </div>
                            <div class="media-body">
                                <h3>Crossrefの照会</h3>
                                <p>世界中の出版社や組織が信頼を置くCrossrefの広範な出版物レポジトリに照らしてすべての引用を検証します。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-security-section></app-security-section>

    <div class="cloud_key_features section-pd bg-light-purple">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-11">
                    <div class="trinka-title mb-0 text-center">
                        <h2>引用分析レポート</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinka引用チェッカーの分析は、表や検出項目ごとの解説などを含むレポートにまとめられます。</p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="btn-group justify-content-center mt-1">
                        <a href="/citation-checker/sample-report" target="_blank" class="filled-btn">引用分析サポートサンプルを見る</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">引用文献の妥当性を数値化</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">スコアを見る</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="trinka-credits section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>レポート生成にはトークンが必要です</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-10">
                    <div class="credit-section">
                        <div class="shape">
                            <svg xmlns="http://www.w3.org/2000/svg" width="745" height="140" viewBox="0 0 745 140" fill="none">
                                <path d="M210.74 99.3391C92.7255 118.025 21.074 68.6063 0 41.5614V169H721.602C749.822 122.013 775.522 23.2037 652.567 3.86251C498.872 -20.314 358.258 75.9822 210.74 99.3391Z" fill="#F5ECFF"/>
                            </svg>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <img src="assets/images/new-credits.svg" alt="クレジット - 英文 チェック ai" />
                            </div>
                            <div class="media-body">
                                <h6>引用分析スコアは無料でご覧いただけます。Trinka トークンの消費で詳細なレポートを生成できます。1トークンで30件までの引用を分析。無料で付与されるトークン、もしくは追加購入いただいたトークンをご利用ください。</h6>
                            </div>
                        </div>
                        <div class="image">
                            <img src="assets/images/credits-banner.svg" alt="クレジット - 英文校正" />
                        </div>
                    </div>
                    <ul>
                        <li><span>*</span>
                            <p>
                                ご利用いただくTrinkaの機能に応じ、トークンが消費されます。<br/>
                                ご利用プランに応じ、毎月無料でトークンが付与されます。詳細は<a [routerLink]="['/features/credits']" class="text-link">こちら</a>。<br/>
                                追加トークンのご購入の際は、まとめてのご購入で割引が適用されます。
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="faqQuestionAnwser section-pd pt-0" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>引用チェッカーに関するよくある質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            Trinka引用チェッカーの使い方は？</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <h4>初めての方でも、3ステップで引用の質を確認いただけます。</h4>
                                            <ol>
                                                <li>Trinkaに<a href="https://cloud.trinka.ai/signup" target="_blank" class="text-link">無料で登録</a></li>
                                                <li>左のナビゲーションパネルの「引用チェッカー」をクリック</li>
                                                <li>文書をアップロード。Google Drive、Dropbox、またはローカルフォルダからアップロードするか、すでにTrinkaのマイドライブにアップロードされている文書を指定します。レポートは数分で生成されます</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">
                                            Trinkaの引用チェックツールはどこで使えるか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinka引用チェックツールは、現在Trinka Cloudプラットフォーム上で、すべてのユーザーの皆様にご利用いただけます。近日中にWordプラグインにも搭載される予定です。</p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            Trinkaの引用チェックツールでは、オープンアクセスか購読型に関わらず引用文献の質のチェックが可能か？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい。有料ジャーナルに掲載された参考文献に関しても、引用の品質チェックが可能です。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            引用チェックレポートを共著者に共有できるか？？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>現在のところ、レポートはお客様専用のTrinka Cloud上でのみ閲覧可能ですが、将来的には共有いただけるようにする予定です。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの
                            使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud - 文法 チェック">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Others_App_MSWord.svg" alt="ms word - 文法 チェック">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/other_Apps_browser.svg" alt="browser - 文法 チェック">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_Apps_enterprise.svg" alt="enterprise - 文法 チェック">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XBuFdCM3xtk"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>